<template>
  <section class="document-edit">
    <header>
      <mo-pageheader>
        <template slot="title">
          {{ $t('title.param') }}
        </template>
        <template slot="action">
          <div class="buttons-container flex ">
            <ba-button
              type="button"
              class="primary"
              @click.native="$router.go(-1)"
            >
              {{ $t('action.return') }}
            </ba-button>
            <ba-button
              class="primary"
              @click.native="savCompany"
            >
              {{ $t('action.save') }}
            </ba-button>
          </div>
        </template>
      </mo-pageheader>
    </header>

    <!-- TABS -->
    <div class="tabs-ctn flex flex-center tabs-margin">
      <div v-if="accessAdherent"
        class="tab"
        @click="clickOnglet(1)"
      >
        {{ $t('sectionTitle.adherents') }}
      </div>
      <div v-if="accessCompany"
        class="tab active"
        @click="clickOnglet(2)"
      >
        {{ $t('sectionTitle.compagnies') }}
      </div>
      <div v-if="accessUser"
        class="tab"
        @click="clickOnglet(3)"
      >
        {{ $t('sectionTitle.utilisateurs') }}
      </div>
      <div v-if="accessDroits"
        class="tab"
        @click="clickOnglet(4)"
      >
        {{ $t('sectionTitle.droits') }}
      </div>
    </div>

    <main>
      <ba-card class="container-form-companie">
        <template slot="header">
          <span>{{ $t('sectionTitle.comptecompanie') }}</span>
        </template>
        <template>
          <div class="cols">
            <div class="col-3">
              <ba-input
                v-model="company.name"
                type="text"
                label="Raison sociale"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.name_2"
                type="text"
                label="Nom"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.country"
                type="text"
                label="Pays"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.street_number"
                type="text"
                label="Numéro de rue"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.address"
                type="text"
                label="Rue"
              />
            </div>
            <div class="col-3">
              <ba-select
                v-model="company.adherent_id"
                label="Adhérent"
                @change.native="reloadVisibleCompany(company.adherent_id)"
              >
                <option
                  v-for="(status, index) in adherents"
                  :value="adherents[index].id"
                >
                  {{ adherents[index].name }}
                </option>
              </ba-select>
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.zip_code"
                type="text"
                label="Code postal"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.city"
                type="text"
                label="Ville"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.phone"
                type="text"
                label="Tél"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model="company.email"
                type="text"
                label="Email"
              />
            </div>
            <!-- Drag & drop section -->
            <div class="col-3 height-filepond">
              <form
                enctype="multipart/form-data"
                @submit.prevent="uploadFile"
              >
                <file-pond
                  ref="pond"
                  name="pond"
                  style="background: #fff; width: 300px"
                  :label-idle="attachedFile.pondLabel"
                  :allow-multiple="false"
                  :max-file-size="attachedFile.maxFileSizeTrunc"
                  :label-file-type-not-allowed="'Fichier invalide'"
                  :file-validate-type-label-expected-types="''"
                  :label-max-file-size-exceeded="'Le fichier est trop lourd'"
                  :label-max-file-size="`La taille d'un fichier doit être de ${attachedFile.maxFileSizeTrunc} maximum`"
                  :allow-file-type-validation="true"
                  :accepted-file-types="attachedFile.pondAcceptedFileType"
                />
              </form>
              <div class="filepond--img">
                <img
                  v-if="company.logo_path != null"
                  :src="handleGetCompanyImage(company.logo_path)"
                  @error="defaultImage"
                >
              </div>
            </div>
            <div class="col-1">
              <span class="text-gras">{{ $t('text.visibiliteCompanies') }}</span>
            </div>
            <div class="col-0">
              <span
                class="bar-full bar-companie"
                style=""
              />
            </div>
            <div class="col-0">
              <div class="cols">
                <div
                  v-for="(company, idx) in companyadherent"
                  :key="`company-${idx}`"
                  class="col-4"
                  @change.stop="changeAjoutVisibilityPiece(idx)"
                >
                  <ba-checkbox
                    v-model="company.visible"
                    :value="company.id"
                    :disabled="disableVisibleCompany(company.id, company.iso_adherent)"
                    >      
                    {{ company.name }}
                  </ba-checkbox>
                </div>
              </div>
            </div>
            <div class="col-1">
              <span class="text-gras">{{ $t('text.visibilitePiecesCompanies') }}</span>
            </div>
            <div class="col-0">
              <span
                class="bar-full bar-companie"
                style=""
              />
            </div>
            <div class="col-0">
              <div class="cols">
                <div
                  v-for="(visiblepiece, idx) in companyvisiblepieces"
                  :key="`visiblepiece-${idx}`"
                  class="col-4" 
                  @change.stop="clickVerifSuprVisibilityPiece(idx)"
                  style="display: flex;"
                >
                              
                  <ba-checkbox
                    v-model="visiblepiece.visibleStock"
                    :value="visiblepiece.id"
                    :disabled="disableVisiblePieces(visiblepiece.id, visiblepiece.iso_adherent)"
                  >
                    {{ visiblepiece.name }}
                  </ba-checkbox>
                </div>
              </div>
            </div>
            <div class="col-1">
              <span class="text-gras">{{ $t('text.coefPiecesCompanies') }}</span>
            </div>
            <div class="col-0">
              <span
                class="bar-full bar-companie"
                style=""
              />
            </div>
            <div class="col-0">
              <div class="cols">
                <div
                  v-for="(visiblepiece, idx) in companyvisiblepieces"
                  :key="`visiblepiece-${idx}`"
                  class="col-4" 
                  @change.stop="clickVerifSuprVisibilityPiece(idx)"
                  style="display: flex;"
                >
                  <ba-input
                    v-model="visiblepiece.discount"
                    type="text"
                    style="width: 14%;"
                    @keypress="onlyForCurrency($event, visiblepiece.discount)"
                  />                
                  <!--                  <ba-checkbox
                    v-model="visiblepiece.visible"
                    :value="visiblepiece.id"
                    :disabled="disableVisiblePieces(visiblepiece.id, visiblepiece.iso_adherent)"
                  >-->
                    {{ visiblepiece.name }}
                  </ba-checkbox>
                </div>
              </div>
            </div>
            <div class="col-1">
              <span class="text-gras">{{ $t('text.orderPiecesCompanies') }}</span>
            </div>
            <div class="col-0">
              <span
                class="bar-full bar-companie"
                style=""
              />
            </div>
            <div class="col-0">
              <div class="cols">
                <div
                  v-for="(visiblepiece, idx) in companyvisiblepieces"
                  :key="`companyOrder-${idx}`"
                  class="col-4" 
                  @change.stop="handleCompanyOrder(idx, visiblepiece.companyOrder)"
                  style="display: flex;"
                >
                  <ba-input
                    v-model="visiblepiece.companyOrder"
                    type="text"
                    style="width: 14%;"
                  />
                  {{ visiblepiece.name }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </ba-card>
      <div>
        <div class="subscription-container flex-stretch flex-space">
          <!-- Abonnement & prelevement section -->
          <ba-card>
            <template slot="header">
              <div class="flex flex-space">
                <span>{{ $t('sectionTitle.aboPrelevement') }}</span>
              </div>
            </template>
            <template>
              <div class="cols">
                <div class="col-2">
                  <section class="basic-date">
                    <label>Date de début</label>
                    <datepicker
                      id="start_deb"
                      v-model="company.start_date"
                      name="start_deb"
                      class="basic-datepicker"
                      format="dd/MM/yyyy"
                      :highlighted="highlighted"
                      :monday-first="true"
                      :language="fr"
                      :disabled-dates="{}"
                    />
                    <ab-icon
                      icon="calendar"
                      iconset="calendarSet"
                    />
                  </section>
                </div>

                <div class="col-2">
                  <section class="basic-date">
                    <label>Date de fin</label>
                    <datepicker
                      id="start_end"
                      v-model="company.end_date"
                      name="start_end"
                      class="basic-datepicker"
                      format="dd/MM/yyyy"
                      :highlighted="highlighted"
                      :monday-first="true"
                      :language="fr"
                      :disabled-dates="{}"
                    />
                    <ab-icon
                      icon="calendar"
                      iconset="calendarSet"
                    />
                  </section>
                </div>

                <div class="col-2">
                  <ba-input
                    v-model="company.monthly_amount"
                    type="text"
                    label="Montant mensuel (€)"
                  />
                </div>
              </div>
            </template>
          </ba-card>

          <!-- Commissions réseau section -->
          <ba-card>
            <template slot="header">
              <div class="flex flex-space">
                <span>{{ $t('sectionTitle.commissionReseau') }}</span>
              </div>
            </template>
            <template>
              <div class="cols">
                <div class="col-1">
                  <ba-input
                    v-model="company.purchase_commission"
                    type="text"
                    label="Commission sur les achats TTC"
                  />
                </div>
                <div class="col-1">
                  <ba-input
                    v-model="company.sale_commission"
                    type="text"
                    label="Commission sur les ventes TTC"
                  />
                </div>
              </div>
            </template>
          </ba-card>

          <!-- Commissions hors réseau section -->
          <ba-card>
            <template slot="header">
              <div class="flex flex-space">
                <span>{{ $t('sectionTitle.commissionHorsReseau') }}</span>
              </div>
            </template>
            <template>
              <div class="cols">
                <div class="col-1">
                  <ba-input
                    v-model="company.network_purchase_commission"
                    type="text"
                    label="Commission sur les achats TTC"
                  />
                </div>
                <div class="col-1">
                  <ba-input
                    v-model="company.network_sale_commission"
                    type="text"
                    label="Commission sur les ventes TTC"
                  />
                </div>
              </div>
            </template>
          </ba-card>

          <!-- Utilisation des Webservices -->
          <ba-card>
            <template slot="header">
              <div class="flex flex-space">
                <span>{{ $t('sectionTitle.utilisationWebServices') }}</span>
              </div>
            </template>
            <template>
              <div class="cols">
                <div class="col-1 select-restreint-label">
                  <ba-checkbox
                    v-model="company.accesRestreint"
                    >      
                    Acces restreint
                  </ba-checkbox>				
                </div>			  
                <div class="col-1">
                  <ba-input
                    v-model="company.limitAccesAaaByCompany"
                    type="text"
                    label="Limite interrogation 3A/TEC pour la compagnie"
                  />
                </div>
                <div class="col-1">
                  <ba-input
                    v-model="company.limitAccesAaaByUser"
                    type="text"
                    label="Limite interrogation 3A/TEC par utilisateur"
                  />
                </div>
              </div>
            </template>
          </ba-card>

          <!-- Message d'absence -->
          <ba-card v-if="accessAjoutMessageAbsence">
            <template slot="header">
              <span>Message d'absence</span>
            </template>
            <template>
              <div class="cols">
                <div class="col-2">
                  <section class="basic-date">
                    <label>Début fermeture</label>
                    <datepicker
                      v-model="company.closure_start"
                      class="basic-datepicker"
                      format="dd/MM/yyyy"
                      :highlighted="highlighted"
                      :monday-first="true"
                      :language="fr"
                      :disabled-dates="{}"
                    />
                    <ab-icon
                      icon="calendar"
                      iconset="calendarSet"
                    />
                  </section>
                </div>
                <div class="col-2">
                  <section class="basic-date">
                    <label>Fin fermeture</label>
                    <datepicker
                      v-model="company.closure_end"
                      class="basic-datepicker position-right"
                      format="dd/MM/yyyy"
                      :highlighted="highlighted"
                      :monday-first="true"
                      :language="fr"
                      :disabled-dates="{}"
                    />
                    <ab-icon
                      icon="calendar"
                      iconset="calendarSet"
                    />
                  </section>
                </div>
              </div>
            </template>
          </ba-card>
        </div>

        <div>
          <ba-card class="container-form-companie">
            <template slot="header">
              <span>{{ $t('sectionTitle.remiseMarge') }}</span>
            </template>
            <template>
              <div class="cols">
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_3"
                    type="text"
                    label="Pièces d'occasion stockées/non-stockées %"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_3)"
                  />
                </div>
                   <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_max"
                    type="text"
                    label="Marge maximal en %"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_max)"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_0"
                    type="text"
                    label="Pièce en Négoce Magasin d'usine"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_0)"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_taux_devis_garage"
                    type="text"
                    label="Garage"
                    @keypress="onlyForCurrency($event, company.aag_taux_devis_garage, 4)"
                  />
                </div>
               
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_1"
                    type="text"
                    label="Marge Echange Standart Boite"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_1)"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_2"
                    type="text"
                    label="Pièce en Négoce Distributeur"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_2)"
                  />
                </div>  
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_4"
                    type="text"
                    label="Marge Echange Standart Moteur (≤ seuil)"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_4)"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_4_high"
                    type="text"
                    label="Marge Echange Standart Moteur (> seuil)"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_4_high)"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_seuil_marg_4"
                    type="text"
                    label="Seuil prix d'achat Moteur ER (€)"
                    @keypress="onlyForCurrency($event, company.aag_seuil_marg_4)"
                  />
                </div>
                <div class="col-4">
                  <ba-input
                    v-model="company.aag_coef_marg_5"
                    type="text"
                    label="Pièce en Négoce alternatif"
                    @keypress="onlyForCurrency($event, company.aag_coef_marg_5)"
                  />
                </div>
              </div>
            </template>
          </ba-card>
        </div>

        <!-- Prelevement bancaire section -->
        <div>
          <ba-card>
            <template slot="header">
              <span>{{ $t('sectionTitle.prelevBqSepa') }}</span>
            </template>
            <template>
              <div class="cols">
                <div class="col-2">
                  <ba-input
                    v-model="company.iban"
                    type="text"
                    label="IBAN"
                  />
                </div>
                <div class="col-2">
                  <ba-input
                    v-model="company.bic"
                    type="text"
                    label="BIC"
                  />
                </div>
                <div class="col-0">
                  <ba-input
                    v-model="company.bank"
                    type="text"
                    label="Banque"
                  />
                </div>
              </div>
              <div class="cols">
                <div class="col-2">
                  <ba-input
                    v-model="company.payment_first_name"
                    type="text"
                    label="Nom"
                  />
                </div>
                <div class="col-2">
                  <ba-input
                    v-model="company.payment_last_name"
                    type="text"
                    label="Prénom"
                  />
                </div>
              </div>
            </template>
          </ba-card>
        </div>

        <!-- Buttons section -->
        <div class="buttons-container flex flex-end button-end">
          <ba-button
            class="primary"
            @click.native="savCompany"
          >
            {{ $t('action.save') }}
          </ba-button>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import {
  AbIcon, BaButton, BaCard, BaCheckbox, BaDropdownInput, BaInput, BaSelect, BaTextarea
} from '@ab/basic-components';

import { mapState } from 'vuex';

import Datepicker from 'vuejs-datepicker';
import { fr } from 'vuejs-datepicker/dist/locale';

import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';

const FilePond = vueFilePond(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

export default {
  name: 'CompanieEdit',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaCheckbox,
    BaDropdownInput,
    BaInput,
    BaSelect,
    BaTextarea,
    Datepicker,
    MoPageheader,
    FilePond
  },
  data() {
    return {
      highlighted: {
        dates: [
          new Date()
        ]
      },
      accessAdherent: false,
      accessCompany: false,
      accessUser: false,
      accessDroits: false,
      accessAjoutMessageAbsence: false,
      company: {
        id: '',
        name: '',
        address: '',
        zip_code: '',
        city: '',
        email: '',
        bank: '',
        iban: '',
        bic: '',
        purchase_commission: '',
        sale_commission: '',
        network_purchase_commission: '',
        network_sale_commission: '',
        payment_first_name: '',
        payment_last_name: '',
        adherent_id: '',
        country: '',
        start_date: '',
        end_date: '',
        name_2: '',
        street_number: '',
        limitAccesAaaByUser: '',
        limitAccesAaaByCompany: '',
        accesRestreint: false,
        monthly_amount: '',
        aag_coef_marg_0 : '',
        aag_coef_marg_1 : '',
        aag_coef_marg_2 : '',
        aag_coef_marg_3 : '',
        aag_coef_marg_4 : '',
        aag_coef_marg_5 : '',
        aag_coef_marg_4_high : '',
        aag_seuil_marg_4 : '',
        aag_coef_marg_max : '',
        aag_taux_devis_garage : ''
      },
      fileStatus: '',
      isFileUploadOngoing: '',
      fileLoading: '',
      files: '',
      fr,
      attachedFile: {
        fileId: null,
        fileStatus: '',
        maxFileSize: 10000000,
        maxFileSizeTrunc: '10 MB',
        pondLabel: 'Glissez votre fichier ou <u>cliquez ici</u> format JPG, PNG, GIF',
        pondAcceptedFileType: [ 'image/jpeg', 'image/png', 'image/gif' ],
        currentPage: 1,
        searchLimit: 5,
        resultatImport: null
      },
    };
  },
  async mounted() {

    this.accessAdherent = await this.$store.dispatch('getAccesRole', {search:29,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessCompany = await this.$store.dispatch('getAccesRole', {search:30,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessUser = await this.$store.dispatch('getAccesRole', {search:31,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

    this.accessDroits = await this.$store.dispatch('getAccesRole', {search:32,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});

    this.accessAjoutMessageAbsence = await this.$store.dispatch('getAccesRole', {search:42,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});

    const { id } = this.$route.params;
    if (id != null) {
      this.company = await this.$store.dispatch('getParamCompany', { id });
      if (this.company.id == '') {
        this.$store.dispatch('displaySnackbar', { text: 'La compagnie n\'a pas été trouvée', mode: 'error' });
        return this.$router.go(-1);
      }
    }

    this.company.street_number = '';
    this.company.address = '';
    if (this.company.address_1 != '' && this.company.address_1 != null) {
      const [ street_number, address ] = this.company.address_1 ? this.company.address_1.split(',') : '';
      this.company.street_number = street_number.trim();
      this.company.address = address.trim();
    }
    await this.$store.dispatch('getParamAllAdherent');

    if (!this.company.id) {
      this.company.id = '';
    }
    await this.$store.dispatch('getParamCompaniesAdherent', { adherent_id: '', company_id: this.company.id });
    await this.$store.dispatch('getParamCompaniesVisiblePieces', { adherent_id: '', company_id: this.company.id });
    this.$store.commit('setSpinner', false);


  },
  computed: {
    ...mapState({ adherents: state => state.adherents.palladherent }),
    ...mapState({ companyadherent: state => state.company.pcompanyadherent }),
    ...mapState({ companyvisiblepieces: state => state.company.pcompanyvisiblepieces }),
  },
  methods: {
    clickOnglet(x) {
      switch (x) {
        case 1:
          this.$router.push('/param/adherents');
          break;
        case 2:
          this.$router.push('/param/companies');
          break;
        case 3:
          this.$router.push('/param/users');
          break;
        case 4:
          this.$router.push('/param/droits');
          break;
        case 5:
          this.$router.push('/param/consignes');
          break;
        default:
      }
    },
	isInt(value) {
        return !isNaN(value) && (function(x) { return (x | 0) === x; })(parseFloat(value))
	},
    // on peut voir les pièces sans les dossiers
    // pour voir les dossiers on donne l'accès aux pièces
    changeAjoutVisibilityPiece(idx) {
      if(this.companyadherent[idx].visible == true || this.companyadherent[idx].visible == 1) {
        this.companyvisiblepieces[idx].visible = 1
      }
    },
    clickVerifSuprVisibilityPiece(idx) {
      if(this.companyvisiblepieces[idx].visible == false) {
        if(this.companyadherent.hasOwnProperty(idx)) {
          if(this.companyadherent[idx].visible == true || this.companyadherent[idx].visible == 1) {
            this.$store.dispatch('displaySnackbar', { text: "Vous devez désactiver au préalable la visiblité des dossiers pour désactiver la visibilité des pièces", mode: 'error' });
            this.companyvisiblepieces[idx].visible = 1
          }
        }  
      }  
    },
    handleCompanyOrder(idx, order) {
      this.companyvisiblepieces[idx].companyOrder = order;
    },
    /* -- Pricing block -- */
    onlyForCurrency($event, dataName, nbdec = 2) {
      //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
 
      const price = String(dataName);
      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || price.indexOf('.') != -1)) { // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (nbdec == 2) {
        if (price != null && price.indexOf(".")>-1 && (price.split('.')[1].length > 1) && $event.target.selectionStart > price.indexOf(".")){
          $event.preventDefault();
        }  
      } 
    },
    disableVisiblePieces(id, iso_adherent) {
      if (this.$route.params.id !== undefined) {
        if (id == this.$route.params.id) {
          return true
        } else {
          return false
        }
      } else {
        if (iso_adherent == 1) {
          return true
        } else {
          return false        
        }
      }  
    },
    disableVisibleCompany(id, iso_adherent) {
      if (this.$route.params.id !== undefined) {
        if (id == this.$route.params.id) {
          return true
        } else {
          return false
        }
      } else {
        if (iso_adherent == 1) {
          return true
        } else {
          return false        
        }
      }  
    },
    affich_checkbox_company(idCompany) {
      if (this.$route.params.id != '') {
        if (this.$route.params.id == idCompany) {
          return false;
        }
      }
      return true;
    },
    reloadVisibleCompany(id_adherent) {
      let idCompany = '';
      if (this.$route.params.id !== undefined) {
        idCompany = this.$route.params.id;
      }
      this.$store.dispatch('getParamCompaniesAdherent', { adherent_id: id_adherent, company_id: idCompany });
      this.$store.dispatch('getParamCompaniesVisiblePieces', { adherent_id: id_adherent, company_id: idCompany });

    },
    /* Get adherent image */
    handleGetCompanyImage(img) {
      const baseApi = process.env.VUE_APP_ROOT_API;
      return `${baseApi}/upload/company/${img}`;
    },
    /* Image for error case */
    defaultImage(e) {
      e.target.src = 'https://cdn.activcar.fr/media/64/brands/default.png';
    },
    async savCompany(redirect = true) {
      this.$store.dispatch('setLoading', true);

      /////////// is number ///////////
      // test saisie accès restreint //	
      /////////////////////////////////

      let flagIntlimitAccesAaaByCompany = 0
      let flagIntlimitAccesAaaByUser = 0
		  
      if (this.company.limitAccesAaaByUser !== null) {
        if (this.company.limitAccesAaaByUser !== '') {
          if (this.isInt(this.company.limitAccesAaaByUser)) {
			flagIntlimitAccesAaaByUser = 1;
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone limite interrogation 3A/TEC par utilisateur de la compagnie n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }

      if (this.company.limitAccesAaaByCompany !== null) {
        if (this.company.limitAccesAaaByCompany !== '') {
          if (this.isInt(this.company.limitAccesAaaByCompany)) {
            flagIntlimitAccesAaaByCompany = 1;
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone limite interrogation 3A/TEC pour la compagnie n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }

	  if ((this.company.accesRestreint === 1) || (this.company.accesRestreint === true)) {
	    if (( flagIntlimitAccesAaaByCompany !== 0) || (flagIntlimitAccesAaaByUser !== 0)) {
			//
	    } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone limite interrogation 3A/TEC pour la compagnie ou pour l'utilisateur doit etre renseignée", mode: 'error' });
            return;
		}
      }	else {
		if (( flagIntlimitAccesAaaByCompany !== 0) || (flagIntlimitAccesAaaByUser !== 0)) {
            this.$store.dispatch('displaySnackbar', { text: "La prise en compte de la zone limite interrogation 3A/TEC pour la compagnie ou pour l'utilisateur est incompatible avec accès restreint désactivé", mode: 'error' });
            return;
		}
	  }
	  
      /////////////////////////////////	
	  
      if (this.company.monthly_amount !== null) {
        if (this.company.monthly_amount != '') {
          if (!isNaN(parseFloat(this.company.monthly_amount)) && isFinite(this.company.monthly_amount)) {
          //
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone Montant mensuel n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }
      if (this.company.purchase_commission !== null) {
        if (this.company.purchase_commission != '') {
          if (!isNaN(parseFloat(this.company.purchase_commission)) && isFinite(this.company.purchase_commission)) {
          //
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone \"Commission sur les achats TTC\" n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }
      if (this.company.sale_commission !== null) {
        if (this.company.sale_commission != '') {
          if (!isNaN(parseFloat(this.company.sale_commission)) && isFinite(this.company.sale_commission)) {
          //
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone \"Commission sur les ventes TTC\" n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }
      if (this.company.network_purchase_commission !== null) {
        if (this.company.network_purchase_commission != '') {
          if (!isNaN(parseFloat(this.company.network_purchase_commission)) && isFinite(this.company.network_purchase_commission)) {
          //
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone \"Commission sur les achats TTC\" n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }
      if (this.company.network_sale_commission !== null) {
        if (this.company.network_sale_commission != '') {
          if (!isNaN(parseFloat(this.company.network_sale_commission)) && isFinite(this.company.network_sale_commission)) {
          //
          } else {
            this.$store.dispatch('displaySnackbar', { text: "La zone \"Commission sur les ventes TTC\" n'est pas numérique", mode: 'error' });
            return;
          }
        }
      }
	  
      if(this.company.adherent_id == '' || this.company.adherent_id == null || this.company.name.trim()  == ''){
        return this.$store.dispatch('displaySnackbar', { text: `L'adherent et la raison sociale sont obligatoires`, mode: 'error' });        
      }

      if (this.$route.params.id == '' || this.$route.params.id == null) {
        const formData = new FormData();
        if (this.$refs.pond.getFile() != null) {
          if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
            return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
          }
          // Check file type
          const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
          if (typeof fileType === 'undefined') {
            return this.$store.dispatch('displaySnackbar', { text: 'Veuillez sélectionner une image ayant un format valide', mode: 'error' });
          }
          const { file } = this.$refs.pond.getFile();
          formData.append('fileUpload', file, file.name);
        }

        const data = await this.$store.dispatch('createParamCompany', {
          id: '',
          name: this.company.name == '' ? ' ' : this.company.name,
          address_1: `${this.company.street_number},${this.company.address}`,
          zip_code: this.company.zip_code == '' ? ' ' : this.company.zip_code,
          city: this.company.city == '' ? ' ' : this.company.city,
          email: this.company.email == '' ? ' ' : this.company.email,
          phone: this.company.phone == '' ? ' ' : this.company.phone,
          bank: this.company.bank == '' ? ' ' : this.company.bank,
          iban: this.company.iban == '' ? ' ' : this.company.iban,
          bic: this.company.bic == '' ? ' ' : this.company.bic,
          purchase_commission: this.company.purchase_commission == '' ? 'null' : this.company.purchase_commission,
          sale_commission: this.company.sale_commission == '' ? 'null' : this.company.sale_commission,
          network_purchase_commission: this.company.network_purchase_commission == '' ? 'null' : this.company.network_purchase_commission,
          network_sale_commission: this.company.network_sale_commission == '' ? 'null' : this.company.network_sale_commission,
          payment_first_name: this.company.payment_first_name == '' ? ' ' : this.company.payment_first_name,
          payment_last_name: this.company.payment_last_name == '' ? ' ' : this.company.payment_last_name,
          adherent_id: this.company.adherent_id == '' ? 'null' : this.company.adherent_id,
          country: this.company.country == '' ? ' ' : this.company.country,
          start_date: this.company.start_date == '' ? 'null' : this.company.start_date,
          end_date: this.company.end_date == '' ? 'null' : this.company.end_date,
          name_2: this.company.name_2 == '' ? ' ' : this.company.name_2,
          street_number: this.company.street_number == '' ? ' ' : this.company.street_number,
          accesRestreint: this.company.accesRestreint === null ? 'null' : this.company.accesRestreint,
          limitAccesAaaByUser: this.company.limitAccesAaaByUser === null ? 'null' : (this.company.limitAccesAaaByUser.toString().trim() == '' ? 'null' : this.company.limitAccesAaaByUser),
          limitAccesAaaByCompany: this.company.limitAccesAaaByCompany === null ? 'null' : (this.company.limitAccesAaaByCompany.toString().trim() == '' ? 'null' : this.company.limitAccesAaaByCompany),
          monthly_amount: this.company.monthly_amount === null ? 'null' : (this.company.monthly_amount.toString().trim() == '' ? 'null' : this.company.monthly_amount),
          aag_coef_marg_0 : this.company.aag_coef_marg_0  == '' ? 'null' : this.company.aag_coef_marg_0,
          aag_coef_marg_1 : this.company.aag_coef_marg_1  == '' ? 'null' : this.company.aag_coef_marg_1,
          aag_coef_marg_2 : this.company.aag_coef_marg_2  == '' ? 'null' : this.company.aag_coef_marg_2,
          aag_coef_marg_3 : this.company.aag_coef_marg_3  == '' ? 'null' : this.company.aag_coef_marg_3,
          aag_coef_marg_4 : this.company.aag_coef_marg_4  == '' ? 'null' : this.company.aag_coef_marg_4,
          aag_coef_marg_5 : this.company.aag_coef_marg_5  == '' ? 'null' : this.company.aag_coef_marg_5,
          aag_coef_marg_4_high : this.company.aag_coef_marg_4_high  == '' ? 'null' : this.company.aag_coef_marg_4_high,
          aag_seuil_marg_4 : this.company.aag_seuil_marg_4  == '' ? 'null' : this.company.aag_seuil_marg_4,
          aag_coef_marg_max : this.company.aag_coef_marg_max  == '' ? 'null' : this.company.aag_coef_marg_max,
          aag_taux_devis_garage : this.company.aag_taux_devis_garage  == '' ? 'null' : this.company.aag_taux_devis_garage,
          closure_start: this.company.closure_start == null ? 'null' : this.company.closure_start,
          closure_end:   this.company.closure_end == null ? 'null' : this.company.closure_end,
          data: formData,
        });

        if (data.last_id_company) {
          if (this.companyadherent.length === undefined) {
            this.companyadherent_tmp = [];
            this.companyadherent_tmp.push({ id: data.last_id_company, visible: 1, company_id: data.last_id_company });
            await this.$store.dispatch('updateParamCompanyAccess', this.companyadherent_tmp);
          } else {
            this.companyadherent.push({ id: data.last_id_company, visible: 1, company_id: data.last_id_company });
            for (let i = 0; i < this.companyadherent.length; i++) {
              this.companyadherent[i].company_id = parseInt(data.last_id_company);
            }
            await this.$store.dispatch('updateParamCompanyAccess', this.companyadherent);
          }
          //
        // this.companyvisiblepieces.push({ id: data.last_id_company, visible: 1, company_id: data.last_id_company });          
          for (let i = 0; i < this.companyvisiblepieces.length; i++) {
            this.companyvisiblepieces[i].company_id = parseInt(data.last_id_company);
          }

          await this.$store.dispatch('updateParamCompanyVisiblePieces', this.companyvisiblepieces);

          this.$store.dispatch('displaySnackbar', { text: 'La compagnie a bien été enregistrée' });
          if (redirect) this.$router.go(-1);
        }
      } else {
        const formData = new FormData();
        if (this.$refs.pond.getFile() != null) {
          if (this.$refs.pond.getFile().fileSize > this.attachedFile.maxFileSize) {
            return this.$store.dispatch('displaySnackbar', { text: `Veuillez ajouter une image dont la taille de dépasse pas ${this.attachedFile.maxFileSizeTrunc}`, mode: 'error' });
          }
          // Check file type
          const fileType = this.attachedFile.pondAcceptedFileType.find(e => e == this.$refs.pond.getFile().file.type);
          if (typeof fileType === 'undefined') {
            return this.$store.dispatch('displaySnackbar', { text: 'Veuillez sélectionner une image ayant un format valide', mode: 'error' });
          }
          const { file } = this.$refs.pond.getFile();
          formData.append('fileUpload', file, file.name);
        }

        const data = await this.$store.dispatch('updateParamCompany', {
          id: this.company.id,
          name: this.company.name == '' ? ' ' : this.company.name,
          address_1: `${this.company.street_number}, ${this.company.address}`,
          zip_code: this.company.zip_code == '' ? ' ' : this.company.zip_code,
          city: this.company.city == '' ? ' ' : this.company.city,
          email: this.company.email == '' ? ' ' : this.company.email,
          phone: this.company.phone == '' ? ' ' : this.company.phone,
          bank: this.company.bank == '' ? ' ' : this.company.bank,
          iban: this.company.iban == '' ? ' ' : this.company.iban,
          bic: this.company.bic == '' ? ' ' : this.company.bic,
          purchase_commission: this.company.purchase_commission == '' ? 'null' : this.company.purchase_commission,
          sale_commission: this.company.sale_commission == '' ? 'null' : this.company.sale_commission,
          network_purchase_commission: this.company.network_purchase_commission == '' ? 'null' : this.company.network_purchase_commission,
          network_sale_commission: this.company.network_sale_commission == '' ? 'null' : this.company.network_sale_commission,
          payment_first_name: this.company.payment_first_name == '' ? ' ' : this.company.payment_first_name,
          payment_last_name: this.company.payment_last_name == '' ? ' ' : this.company.payment_last_name,
          adherent_id: this.company.adherent_id == '' ? ' ' : this.company.adherent_id,
          country: this.company.country == '' ? ' ' : this.company.country,
          start_date: this.company.start_date == '' ? ' ' : this.company.start_date,
          end_date: this.company.end_date == '' ? ' ' : this.company.end_date,
          name_2: this.company.name_2 == '' ? ' ' : this.company.name_2,
          street_number: this.company.street_number == '' ? ' ' : this.company.street_number,
          accesRestreint: this.company.accesRestreint === null ? 'null' : this.company.accesRestreint,		  
          limitAccesAaaByUser: this.company.limitAccesAaaByUser === null ? 'null' : (this.company.limitAccesAaaByUser.toString().trim() == '' ? 'null' : this.company.limitAccesAaaByUser),
          limitAccesAaaByCompany: this.company.limitAccesAaaByCompany === null ? 'null' : (this.company.limitAccesAaaByCompany.toString().trim() == '' ? 'null' : this.company.limitAccesAaaByCompany),
          monthly_amount: this.company.monthly_amount === null ? 'null' : (this.company.monthly_amount.toString().trim() == '' ? 'null' : this.company.monthly_amount),
          aag_coef_marg_0 : this.company.aag_coef_marg_0  == '' ? 'null' : this.company.aag_coef_marg_0,
          aag_coef_marg_1 : this.company.aag_coef_marg_1  == '' ? 'null' : this.company.aag_coef_marg_1,
          aag_coef_marg_2 : this.company.aag_coef_marg_2  == '' ? 'null' : this.company.aag_coef_marg_2,
          aag_coef_marg_3 : this.company.aag_coef_marg_3  == '' ? 'null' : this.company.aag_coef_marg_3,
          aag_coef_marg_4 : this.company.aag_coef_marg_4  == '' ? 'null' : this.company.aag_coef_marg_4,
          aag_coef_marg_5 : this.company.aag_coef_marg_5  == '' ? 'null' : this.company.aag_coef_marg_5,
          aag_coef_marg_4_high : this.company.aag_coef_marg_4_high  == '' ? 'null' : this.company.aag_coef_marg_4_high,
          aag_seuil_marg_4 : this.company.aag_seuil_marg_4  == '' ? 'null' : this.company.aag_seuil_marg_4,
          aag_coef_marg_max : this.company.aag_coef_marg_max  == '' ? 'null' : this.company.aag_coef_marg_max,
          aag_taux_devis_garage : this.company.aag_taux_devis_garage  == '' ? 'null' : this.company.aag_taux_devis_garage,
          closure_start: this.company.closure_start == null ? 'null' : this.company.closure_start,
          closure_end:   this.company.closure_end == null ? 'null' : this.company.closure_end,
          data: formData,
        });
        if (data.last_id_company) {
          this.companyadherent.push({ id: data.last_id_company, visible: 1, company_id: data.last_id_company });
          for (let i = 0; i < this.companyadherent.length; i++) {
            this.companyadherent[i].company_id = parseInt(data.last_id_company);
          }
          await this.$store.dispatch('updateParamCompanyAccess', this.companyadherent);
          //
        //  this.companyvisiblepieces.push({ id: data.last_id_company, visible: 1, company_id: data.last_id_company });          
          for (let i = 0; i < this.companyvisiblepieces.length; i++) {
            this.companyvisiblepieces[i].company_id = parseInt(data.last_id_company);
          }
          
          await this.$store.dispatch('updateParamCompanyVisiblePieces', this.companyvisiblepieces);

          this.$store.dispatch('displaySnackbar', { text: 'La compagnie a bien été enregistrée' });
          if (redirect) this.$router.go(-1);
        }
      }
      this.$store.commit('setSpinner', false);
    },
  },
};
</script>
<style scoped>
  /* MODAL */
  #app .modal.px-0 .v--modal .ba-card .main {
    padding-left: 0;
    padding-right: 0;
  }
  .car-client-container.mb-0 {
    margin-bottom:0;
  }
.text-gras {
  font-weight: bold;
}

.bar-companie {
  margin-top: 6px;
  margin-bottom: 20px;
}

.col-33 {
  width: 33%;
  height: auto;
}
.tabs-margin {
  margin-bottom: 2rem;
}

.button-end {
  margin-top: 2rem;
}
.filepond--wrapper {
  margin-top: 0;
}

.height-filepond {
  display:flex;
}

.height-filepond form {
  margin-right: 20px;
  width: 65%;
}

.filepond--img {
  width: calc(35% - 20px);
}

.filepond--img img {
    max-width: 100%;
    height: auto;
    max-height: 66px;
    padding-left: 56px;
}

.select-restreint-label {
	font-size: 11px;
}

</style>
<style src="@/assets/styles/datepickers.css"></style>
<style src="@/assets/styles/requests.css"></style>
<style src="@/assets/styles/filepond.css"></style>
<style src="@/assets/styles/tabs.css"></style>
<style src="@/assets/styles/tooltips.css"></style>
<style src="@/assets/styles/modals.css"></style>
